












'use strict';

function emptyFunction(){}

var BackAndroid={
exitApp:emptyFunction,
addEventListener:function addEventListener(){
return{
remove:emptyFunction};

},
removeEventListener:emptyFunction};


module.exports=BackAndroid;


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/apis/BackAndroid/index.js
// module id = 686
// module chunks = 0